import React from 'react';
import ReactDOM from 'react-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { ApolloClient, ApolloLink } from 'apollo-boost';
import { setContext } from 'apollo-link-context';
import { HttpLink } from 'apollo-link-http';
import { ApolloProvider } from 'react-apollo';
import { onError } from 'apollo-link-error';

import { ReduxCache, apolloReducer } from 'apollo-cache-redux';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux'
import { ConnectedRouter, routerReducer, routerMiddleware } from 'react-router-redux'
import { reducer as formReducer } from 'redux-form'
import rootReducer from './reducers';

import createHistory from 'history/createBrowserHistory'

import * as CONFIG from './constants/Config';

import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import introspectionQueryResultData from './fragmentTypes.json';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData
});

const history = createHistory();

const middleware = routerMiddleware(history);

const store = createStore(
    combineReducers({
        apollo: apolloReducer,
        router: routerReducer,
        form: formReducer,
        root: rootReducer
    }),
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
    applyMiddleware(middleware)
)

const cache = new ReduxCache({store, fragmentMatcher})

const errorLink = onError(({graphQLErrors, networkError, operation, response }) => {
    if (graphQLErrors){
        graphQLErrors.map(({message, locations, path}) => {
            // location = location ? location : "undefined";
            // path = path ? path : "undefined";
            return console.log(
                `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}`
            );
        })
    };
    if (networkError){
        console.log(`[Network error]: ${networkError}`);
        if (networkError.statusCode === 401){

        }
    }
    //console.log(`[Response]: ${response}`)
});

const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = localStorage.getItem('token');
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : "",
      }
    }
  });

const customFetch = (uri,options) => {
    this.refreshingPromise = null;

    var initialRequest = fetch(uri,options);
    return initialRequest.then((response) => {
        return(response.json())
    }).then((json) => {
        //console.log(json);
        if (json && json.message && json.message === 'Failed to authenticate token.'){
            localStorage.removeItem('token');
            //TODO: add logout here
        }
        var result = {};
        result.ok = true;
        result.json = () => new Promise((resolve,reject) => {
            resolve(json);
        })
        result.text = () => new Promise((resolve,reject) => {
            resolve(JSON.stringify(json));
        })
        return result;
    })
}

const client = new ApolloClient({
    // By default, this client will send queries to the
    //  `/graphql` endpoint on the same host
    // Pass the configuration option { uri: YOUR_GRAPHQL_API_URL } to the `HttpLink` to connect
    // to a different host
    link : ApolloLink.from([
        errorLink,
        authLink,
        new HttpLink({
            uri: `${CONFIG.SERVER_IP}/graphql`,
            fetch: customFetch
        })
    ]),
    cache
  });


ReactDOM.render(
    <ApolloProvider client={client}>
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </Provider>
    </ApolloProvider>
, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js